const routes = [
  {
    path: 'assembly-planning-dover',
    component: () => import(/* webpackChunkName: "assembly-planning-dover" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
    children: [
      {
        path: '',
        name: 'assemblyPlanningDover',
        component: () => import(/* webpackChunkName: "assembly-planning-dover" */ './views/ProductionPlanning.vue'),
      },
      {
        path: 'settings/:id?',
        name: 'assemblyPlanDoverSettings',
        component: () => import(/* webpackChunkName: "assembly-planning-dover" */ './views/ProductionPlanSettings.vue'),
      },
      {
        path: 'plan',
        name: 'addAssemblyPlanDover',
        component: () => import(/* webpackChunkName: "assembly-planning-dover" */ './views/AddProductionPlan.vue'),
      },
      {
        path: 'reorder',
        name: 'reorderAssemblyPlansDover',
        component: () => import(/* webpackChunkName: "assembly-planning-dover" */ './views/ReorderProductionPlans.vue'),
      },
      {
        path: 'plan/:id',
        name: 'assemblyPlanDetailsDover',
        component: () => import(/* webpackChunkName: "assembly-planning-dover" */ './views/ProductionPlanDetails.vue'),
        props: true,
      },
      {
        path: 'plan/:id/edit',
        name: 'editAssemblyPlanDover',
        component: () => import(/* webpackChunkName: "assembly-planning-dover" */ './views/EditProductionPlan.vue'),
        props: true,
      },
      {
        path: 'plan/:id/duplicate',
        name: 'duplicateAssemblyPlanDover',
        component: () => import(/* webpackChunkName: "assembly-planning-dover" */ './views/DuplicateProductionPlan.vue'),
        props: true,
      },
    ],
  },
];

export default routes;
